import { Component, ErrorInfo, ReactNode } from 'react';
import { recordError } from '../client/OCAnalytics';

interface AppErrorBoundaryProps {
    children: ReactNode;
}

interface AppErrorBoundaryState {
    hasError: boolean;
}

/**
 * Last-resort boundary around the whole app: reports render crashes to
 * Crashlytics/Analytics and offers a reload. Deliberately renders plain HTML —
 * if React crashed this deep, Ionic components may be part of the problem.
 */
export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
    state: AppErrorBoundaryState = { hasError: false };

    static getDerivedStateFromError(): AppErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        recordError(error, 'react_render');
        console.error('(AppErrorBoundary)', error, errorInfo.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    padding: '2rem',
                    textAlign: 'center',
                    fontFamily: 'sans-serif'
                }}>
                    <h2>Something went wrong</h2>
                    <p>An unexpected error occurred. Please restart the app.</p>
                    <button
                        style={{ padding: '0.75rem 1.5rem', fontSize: '1rem' }}
                        onClick={() => window.location.assign('/')}
                    >
                        Reload
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
